import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-petition-form',
  templateUrl: './petition-form.component.html',
  styleUrls: ['./petition-form.component.css']
})
export class PetitionFormComponent implements OnInit {

  title = "Add Petition";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/petition/petition-form/petition-form.component.ts